<app-dialog-template [hasHeaderFooterGap]="true">
  <app-dialog-template-header>
    <app-dialog-template-title>
      {{ "FIELD_SETTINGS_DIALOG.TITLE" | translate }}
    </app-dialog-template-title>
    <app-dialog-template-header-actions></app-dialog-template-header-actions>
  </app-dialog-template-header>
  <app-dialog-template-body [hasPaddingY]="true">
    <form class="c-field-settings-dialog__form" [formGroup]="form">
      <app-dialog-template-searchable [bodyScrollable]="false">
        <ng-template appDialogTemplateSearchableHeader>
          <app-bui-search [formControl]="searchTermFormControl"></app-bui-search>
        </ng-template>
        <ng-template appDialogTemplateSearchableSubheader>
          <ng-container *ngIf="!searchTermFormControl?.value?.length">
          <span class="c-field-settings-dialog__link" *ngIf="!areAllSelected"
            (click)="setAll(true)">{{ 'COMMON.SELECT_ALL' | translate }}</span>
            <span class="c-field-settings-dialog__link" *ngIf="areAllSelected"
              (click)="setAll(false)">{{ 'COMMON.DESELECT_ALL' | translate }}</span>
          </ng-container>
        </ng-template>
        <ng-template appDialogTemplateSearchableBody>
          <div class="c-field-settings-dialog__list" cdkDropList
            (cdkDropListDropped)="drop($event)">
            <div class="c-field-settings-dialog__list-item-wrapper"
              *ngFor="let field of filteredFields | fieldSettingsSearch:fields:searchValue"
              cdkDrag
              [cdkDragDisabled]="filteredFields.length < fields.length">
              <div class="c-field-settings-dialog__list-item">
                <app-bui-drag-handle [iconSize]="'tiny'" cdkDragHandle></app-bui-drag-handle>
                <div class="c-field-settings-dialog__list-item-content">
                  <app-checkbox [formControlName]="field?.dbName">
                    {{ field?.label }}
                  </app-checkbox>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
        <ng-container *ngIf="!data.showSetForAllSwitcher">
          <ng-template appDialogTemplateSearchableFooter *ngIf="userContext.isOwnerOrAdmin">
            <div class="c-field-settings-dialog__set-for-all-slider">
              <app-bui-slide-toggle
                [formControl]="setForAllFormControl"
                [label]="'USER_FIELD_SETTINGS.SET_FOR_ALL_USERS' | translate"
                [labelPosition]="'after'"
                [hideTooltip]="true">
              </app-bui-slide-toggle>
            </div>
          </ng-template>
        </ng-container>
      </app-dialog-template-searchable>
    </form>
  </app-dialog-template-body>
  <app-dialog-template-footer>
    <app-bui-button-label
      [comboStyle]="DialogTemplateButtonComboStyleEnum.OUTLINE"
      (clickEvent)="dialogRef.close()">
      {{ "COMMON.CANCEL" | translate }}
    </app-bui-button-label>
    <app-bui-button-label
      [comboStyle]="DialogTemplateButtonComboStyleEnum.FILL_GRADIENT_1"
      [disabled]="formInvalid"
      (clickEvent)="save()">
      {{ "COMMON.SAVE" | translate }}
    </app-bui-button-label>
  </app-dialog-template-footer>
</app-dialog-template>
